import React from 'react';
import { motion } from 'framer-motion';
import { Stack } from '@mui/material';
import './TextLoader.scss';
import clsx from 'clsx';

interface TextLoaderProps {
  size?: number;
  className?: string;
}

export const TextLoader = ({ size = 4, className }: TextLoaderProps) => {
  return (
    <Stack
      direction="row"
      gap={0.25}
      className={clsx('text-loader', className)}
      alignItems="center"
    >
      {[0, 1, 2].map((index) => (
        <motion.div
          key={index}
          className="text-loader__dot"
          animate={{
            opacity: [0.3, 1, 0.3],
            scale: [0.8, 1.2, 0.8],
          }}
          transition={{
            duration: 1.2,
            repeat: Infinity,
            delay: index * 0.2,
            ease: 'easeInOut',
          }}
          style={{
            width: `${size}px`,
            height: `${size}px`,
          }}
        />
      ))}
    </Stack>
  );
};
